'use es6';

import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { setXrayInpageGathererArtifacts } from 'ContentEditorUI/redux/actions/xrayActions';
import { getInpageGathererKeys } from 'ContentEditorUI/redux/selectors/optimizationSelectors';
import { getActiveSidebarPanel } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getContentModelMetaDescription } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getHasUnsavedChanges } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { GathererConfig } from 'xray-recommendation-lib/gatherers/allGatherers';
const useInpageEditorStateSelectors = () => {
  const store = useStore();
  const inpageEditorStateSelectors = useMemo(() => {
    const selectContentModelMetaDescription = () => {
      return getContentModelMetaDescription(store.getState());
    };
    return {
      selectContentModelMetaDescription
    };
  }, [store]);
  return inpageEditorStateSelectors;
};
const XRayPageCrawlerContainer = () => {
  const activeSidebarPanel = useSelector(getActiveSidebarPanel);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const dispatch = useDispatch();
  const inpageEditorStateSelectors = useInpageEditorStateSelectors();
  const inpageGathererKeys = useSelector(getInpageGathererKeys);
  useEffect(() => {
    const shouldRunGatherers = activeSidebarPanel === 'optimizer' && !hasUnsavedChanges;
    if (!shouldRunGatherers) {
      return;
    }
    const inpageEditorArtifacts = inpageGathererKeys.reduce((newArtifacts, key) => {
      const gatherer = GathererConfig[key];
      const artifact = gatherer.execute({
        userDOM: document,
        editorStateSelectors: inpageEditorStateSelectors
      });
      newArtifacts[key] = artifact;
      return newArtifacts;
    }, {});
    dispatch(setXrayInpageGathererArtifacts(inpageEditorArtifacts));
  }, [activeSidebarPanel, inpageEditorStateSelectors, hasUnsavedChanges, inpageGathererKeys, dispatch]);
};
XRayPageCrawlerContainer.propTypes = {};
export default XRayPageCrawlerContainer;